// extracted by mini-css-extract-plugin
export default {"graph":"styles_graph__ZBaYl"};